import React from 'react';
import '../../Styles/AppointmentStatisticsCard.css';

const AppointmentStatisticsCard = ({ appointment }) => {
    return (
        <div className={`appointment-card ${appointment.percentage >= 0 ? 'good' : 'bad'}`}>
            <h4>{appointment.subject}</h4>
            <p>Sags.nr: {appointment.hnAppointmentID}</p>
            <p>Kostpris total: {appointment.costPrice} kr</p>
            <p>Kostpris for arbejde: {appointment.costPriceWork} kr</p>
            <p>Vare Kostpris: {appointment.costPriceInventoryItem} kr</p>
            <p>Fakturet Beløb: {appointment.invoicedAmount} kr</p>
            <p>DT: {appointment.percentage.toFixed(2)}%</p>
        </div>
    );
};

export default AppointmentStatisticsCard;
